import React, { useState, useEffect, useRef } from "react";


import {
  Compass,
  Sparkles,
  Mountain,
  Waves,
  Building2,
  Trees,
  Landmark,
  ShoppingBag,
  MoonStar,
  ChevronRight,
  Search
} from "lucide-react";

import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { fetchAllTourPlaces, getTopThingsToDoList } from "../../services/restapiService";
import { useSearchParams } from "react-router-dom";



export default function AttractionsSection() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


  const [tourPlaces, setTourPlaces] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedTag, setSelectedTag] = useState("all");

  const [searchParams] = useSearchParams();
  const selectedCategory = searchParams.get("category");

  const [attractions, setAttractions] = useState([]);
  const [loading, setLoading] = useState(true);


  const navigate = useNavigate();
  useEffect(() => {
    const main = document.querySelector("main");

    if (main) {
      main.style.backgroundColor = "#f1f1f1";
    }

    return () => {
      if (main) {
        main.style.backgroundColor = "";
      }
    };
  }, []);



  useEffect(() => {
    const fetchAttractions = async () => {
      try {
        setLoading(true);

        const token = localStorage.getItem("token");

        const response = await getTopThingsToDoList(token);

        const data = response.data.data || [];

        console.log("All attractions:", data);
        console.log("Selected category:", selectedCategory);

        const filteredData = selectedCategory
          ? data.filter(
            (item) =>
              item.category?.trim().toLowerCase() ===
              selectedCategory.trim().toLowerCase()
          )
          : data;

        setAttractions(filteredData);
      } catch (error) {
        console.error(
          "Failed to fetch attractions:",
          error
        );
      } finally {
        setLoading(false);
      }
    };

    fetchAttractions();
  }, [selectedCategory]);



  useEffect(() => {
    const loadPlaces = async () => {
      try {
        const res = await fetchAllTourPlaces();
        const data = res.data.data || [];

        console.log("Top destinations:", data);

        setTourPlaces(data);
      } catch (error) {
        console.error("Failed to fetch display titles:", error);
      }
    };

    loadPlaces();
  }, []);


  const getTagIcon = (tag) => {
    const value = tag.toLowerCase();

    if (value.includes("water")) {
      return Waves;
    }

    if (
      value.includes("park") ||
      value.includes("theme")
    ) {
      return Sparkles;
    }

    if (
      value.includes("wildlife") ||
      value.includes("tiger") ||
      value.includes("animal")
    ) {
      return Trees;
    }

    if (
      value.includes("city") ||
      value.includes("sightseeing")
    ) {
      return Building2;
    }

    if (
      value.includes("shopping")
    ) {
      return ShoppingBag;
    }

    if (
      value.includes("night")
    ) {
      return MoonStar;
    }

    if (
      value.includes("museum") ||
      value.includes("temple")
    ) {
      return Landmark;
    }

    return Mountain;
  };

  const [searchTerm, setSearchTerm] = useState("");

  const filteredCategories = categories.filter((item) =>
    item.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredAttractions = attractions.filter((item) => {
    const search = searchTerm.trim().toLowerCase();

    if (!search) return true;

    return (
      item.title?.toLowerCase().includes(search) ||
      item.description?.toLowerCase().includes(search) ||
      item.category?.toLowerCase().includes(search)
    );
  });

  const handleBooking = (id) => {
    console.log(id)
    navigate(`/trip-details/${id}`);
  };


  return (
    <div className="bg-[#f5f7fb] py-12">
      <div className="container">
        <div className="grid gap-2 lg:grid-cols-[240px_minmax(0,1fr)_280px]">

          {/* LEFT SECTION — Categories */}
          <aside className="rounded-2xl bg-white p-4 shadow-md">
            <div className="">
              <div className="relative pl-4 pt-2">
                <h4 className="mt-1 font-bold text-black">
                  Browse Attractions
                </h4>
              </div>

              {/* Search */}
              <div className="relative mt-4">
                <Search
                  size={18}
                  className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
                />

                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="Search attractions..."
                  className="w-full rounded-xl border border-slate-200 bg-slate-50 py-2.5 pl-10 pr-4 text-sm text-slate-700 outline-none transition focus:border-violet-500 focus:bg-white focus:ring-2 focus:ring-violet-100"
                />
              </div>

              <div className="space-y-3 py-2 pt-4">
                {filteredCategories.length > 0 ? (
                  filteredCategories.map((item) => {
                    const Icon = item.icon;

                    return (
                      <button
                        key={item.value}
                        onClick={() => setSelectedTag(item.value)}
                        className={`group flex w-full items-center justify-between rounded-xl transition-all duration-300 ${selectedTag === item.value
                          ? "bg-violet-50 text-black"
                          : "bg-white hover:bg-slate-50"
                          }`}
                      >
                        <div className="flex items-center gap-4">
                          <div
                            className={`rounded-lg p-2 ${selectedTag === item.value
                              ? "bg-violet-100"
                              : "bg-slate-100 group-hover:bg-violet-50"
                              }`}
                          >
                            <Icon
                              size={24}
                              color="#7c3aed"
                            />
                          </div>

                          <div className="text-left">
                            <h4
                              className={`text-sm font-semibold ${selectedTag === item.value
                                ? "text-violet-700"
                                : "text-slate-700"
                                }`}
                            >
                              {item.title}
                            </h4>
                          </div>
                        </div>
                      </button>
                    );
                  })
                ) : (
                  <div className="py-6 text-center text-sm text-slate-400">
                    No attractions found
                  </div>
                )}
              </div>
            </div>
          </aside>

          <section className="rounded-2xl bg-white p-4 shadow-md">
            <div className="relative pl-4 pt-2">
              <h4 className="mt-1 font-bold text-black">
                Attractions
              </h4>
            </div>

            {/* Dynamic Attractions */}
            <div className="grid gap-6 sm:grid-cols-2 2xl:grid-cols-3 pt-4">
              {filteredAttractions.length > 0 ? (
                filteredAttractions.map((item) => (
                  <div
                    onClick={() => handleBooking(item.id)}
                    key={item.id}
                    className="cursor-pointer group overflow-hidden rounded-[10px] border border-slate-200 bg-white shadow-md shadow-slate-200/50 transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl hover:shadow-slate-300/60"
                  >
                    {/* Image */}
                    <div className="relative h-52 overflow-hidden bg-slate-100">
                      <img
                        src={
                          item.image
                            ? `${API_BASE_URL}${item.image}`
                            : "/placeholder.png"
                        }
                        alt={item.title}
                        loading="lazy"
                        className="h-full w-full object-cover transition duration-700 group-hover:scale-110"
                      />
                    </div>

                    {/* Content */}
                    <div className="p-4">
                      <h3 className="text-lg text-center uppercase font-bold text-slate-900">
                        {item.title}
                      </h3>
                    </div>
                  </div>
                ))
              ) : (
                <div className="col-span-full flex min-h-[250px] items-center justify-center">
                  <p className="text-sm font-medium text-slate-400">
                    No attractions found
                  </p>
                </div>
              )}
            </div>
          </section>

          {/* RIGHT SECTION — Destinations */}
          <aside className="rounded-2xl bg-white p-4 shadow-md">
            <div>
              <div className="relative pl-4 pt-2">
                <h4 className="mt-1 font-bold text-black">
                  Top Destinations
                </h4>
              </div>

              <div className="space-y-3 py-2 pt-4">
                {tourPlaces.map((item) => (
                  <div
                    key={item.id}
                    onClick={() => navigate(`/attractions`)}
                    className="group flex cursor-pointer items-center gap-4 rounded-2xl bg-white p-1 transition-all duration-300 hover:-translate-y-1 hover:border-blue-200 hover:shadow-lg"
                  >
                    <div className="relative shrink-0">
                      <img
                        src={
                          item.display_image
                            ? `${API_BASE_URL}${item.display_image}`
                            : "/placeholder.png"
                        }
                        alt={item.category}
                        className="h-16 w-16 rounded-sm object-cover transition duration-500 group-hover:scale-105"
                      />
                    </div>

                    <div className="flex flex-1 flex-col">
                      <h4 className="text-base font-bold capitalize text-slate-800 group-hover:text-blue-600">
                        {item.category}
                      </h4>
                    </div>
                  </div>
                ))}


                <div onClick={() => navigate(`/attractions`)} className="group flex cursor-pointer items-center justify-between rounded-2xl border-t border-slate-100 p-4 transition-all duration-300 hover:bg-violet-50">
                  <h6 className="font-semibold text-[#7c3aed]">
                    View All Destinations
                  </h6>

                  <ChevronRight
                    size={20}
                    className="text-[#7c3aed] transition-transform duration-300 group-hover:translate-x-1"
                  />
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </div>

  );
}
